import { useSimulatorToInsertContact } from '@nice-ccf/ui-components';
import { ApiResponse } from 'libs/react/ui-components/src/lib/ccf-app-space/ccf-copilot/ccf-copilot-api';
import {
  processApiResponse,
  saveCopilotConfig,
  saveIndexConfig,
  setIsCopilotEnabled,
} from 'libs/react/ui-components/src/lib/ccf-app-space/ccf-copilot/ccf-copilot-util';

let channel: BroadcastChannel;
// eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
export function simulatorBroadcastListener(
  dispatch: any,
  agentCurrentStatus?: string
) {
  channel = new BroadcastChannel('simulator_channel');
  channel.onmessage = (msg: { type: string; data: any; ignore? :any}) => {
    const type = msg?.data?.data?.type;
    const data = msg?.data?.data?.data;
    const ignore = msg?.data?.data?.ignore ?? false;
    const showGreenConfidenceDot = msg?.data?.data?.showGreenConfidenceDot;

    switch (type) {
      case 'insertContact':
        if (agentCurrentStatus !== 'Working-OB') {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          dispatch(useSimulatorToInsertContact(data));
        }
        break;
      case 'saveCopilotConfig':
        saveCopilotConfig(data, dispatch);
        break;
      case 'process-utterance':
        processApiResponse(data as unknown as ApiResponse, dispatch, 'Digital', ignore, false, showGreenConfidenceDot);
        break;
      case 'saveIndexConfig':
        saveIndexConfig(data, dispatch);
        break;
      // case 'setIsCopilotEnabled':
      //   setIsCopilotEnabled(data, dispatch);
      //   break;
      default:
        break;
    }
  };
}

// eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
export const closechannel = () => {
  if (channel && channel.name === 'simulator_channel' || channel.name === 'patron_channel') {
    channel.close();
  }
};

/**
   * @example patronBroadcastListener()
*/
export function patronBroadcastListener(
  dispatch: any,
  agentCurrentStatus?: string
) {
  channel = new BroadcastChannel('patron_channel');
  channel.onmessage = (msg: { type: string; data: any; ignore? :any }) => {
    console.log("Message received in patronBroadcastListener:", msg);
    const type = msg?.data?.data?.type;
    const data = msg?.data?.data?.data;
    const ignore = msg?.data?.data?.ignore ?? false;

    switch (type) {
      case 'process-utterance':
        processApiResponse(data as unknown as ApiResponse, dispatch, 'Digital', ignore);
        break;
      default:
        break;
    }
  };
}
